import { Panel } from "primereact/panel";
import { TextField } from "../../../components/TextField";

const formatarLabel = (chave: string): string => {
  return chave
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase()
    .replace(/(^|\s)\S/g, (letra) => letra.toUpperCase());
};

const formatarValor = (valor: any): string => {
  if (valor === null || valor === undefined || valor === "") return "Não informado";
  if (typeof valor === "boolean") return valor ? "Sim" : "Não";
  return String(valor);
};

const isScalar = (valor: any) => valor === null || typeof valor !== "object";

export function DadosDinamicos({ dados }: { dados: any }) {
  if (dados === null || dados === undefined) return null;

  if (Array.isArray(dados)) {
    if (dados.length === 0) {
      return <p>Nada consta</p>;
    }
    return (
      <>
        {dados.map((item, index) => (
          <div key={index}>
            {index > 0 && <br />}
            {isScalar(item) ? (
              <p>{formatarValor(item)}</p>
            ) : (
              <Panel header={`Registro ${index + 1}`}>
                <DadosDinamicos dados={item} />
              </Panel>
            )}
          </div>
        ))}
      </>
    );
  }

  if (isScalar(dados)) {
    return <p>{formatarValor(dados)}</p>;
  }

  const campos = Object.entries(dados).filter(([, valor]) => isScalar(valor));
  const complexos = Object.entries(dados).filter(([, valor]) => !isScalar(valor));

  return (
    <>
      {campos.length > 0 && (
        <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
          {campos.map(([chave, valor]) => (
            <TextField key={chave} label={formatarLabel(chave)} value={formatarValor(valor)} />
          ))}
        </section>
      )}
      {complexos.map(([chave, valor]) => (
        <div key={chave}>
          <br />
          <Panel header={formatarLabel(chave)}>
            <DadosDinamicos dados={valor} />
          </Panel>
        </div>
      ))}
    </>
  );
}
